import { Header } from '@tanstack/react-table';
import React from 'react';
import { Load } from '../../../types';
import { TableSortLabel } from '@mui/material';

interface LoadTableHeaderCellProps {
    header: Header<Load, any>;
    label: string;
}

export const LoadTableHeaderCell: React.FC<LoadTableHeaderCellProps> = (props) => {
    const { header, label } = props;
    const canSort = header.column.getCanSort();
    const isSorted = header.column.getIsSorted();

    return (
        <div
            className='lt-header-text'
            style={canSort ? { cursor: 'pointer' } : undefined}
            onClick={() => {
                if (canSort) {
                    header.column.toggleSorting();
                }
            }}
        >
            {label}
            {canSort && <TableSortLabel
                active={Boolean(isSorted)}
                direction={isSorted ? isSorted : undefined}
            />}
        </div>
    );
};
